import {
    getBottomLayerBankListTmpl,
    getBottomLayerBankList2Tmpl,
    getBottomLayerOpenBankListTmpl,
    getBottomLayerOpenBankList2Tmpl,
    getBottomLayerBankFirmListTmpl,
    getBottomLayerBankFirmItemTmpl,
    getBottomLayerTmpl,
} from "./templates/html.template";
import {Swiper} from 'swiper';
import {chunk} from "../utils/util";
import Popup from "./base/Popup";
import {SWIPER_GLOBAL_COMMON} from "../utils/constants";
import {initData, setSelectText} from "../functions/select.common";
import {getBottomLayerSelectItemTmpl} from "./templates/popup.template";
import {getSelectButtonClose} from "./templates/html.template";
import { _colorStringFilter } from "gsap/gsap-core";

import {
    isA11yCheckVersion,
    isA11ySetAttr,
    isA11yRemoveClass,
    isA11yRadioGroup,
    isA11ySelectPopupOpenFocus,
    isA11yForceTargetFocus,
    isPopupMakeCloseButtonOne,
    isA11ySelectInputCombo,
    isA11yCheckVoiceOverFocusPrevent,
} from "../functions/a11y.ui";
/**
 * PopupSelect
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_select.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_select.html)
*/
class PopupSelect extends Popup {
    defaults = {
        type: 'select-single',
        optional: false,
        delbtn: 'hide'
    };

    constructor(el, options) {
        super('popupSelect', el);

        this.init(el, options);
    }

    init(el, options) {
        this.popupInit(el, options);

        initData(this);
        setSelectText(this);
        this.detachEvents();
        this.attachEvents();

        if (this.defaults.delbtn == 'show') {
            this.defaultSelected();
        }
        
        if ($(el).attr('data-type') == 'select-double' && $(el).attr('data-item') == 'account' && !$(el).closest('.ui-input').hasClass('noline')) { // FETASK-1382 : 추가
            if ($(el).find('option[selected]').index() != 0 && $(el).closest('.ui-input').find('.txt-value02').length > 0 && $(el).find('option[selected]').attr('data-all') == undefined) {
                $(el).closest('.ui-input').addClass('type3')
            }
        }
        if ($(el).attr('data-type') == 'select-openbank' && $(el).attr('data-double') == 'true' && $(el).closest('.ui-input').find('.txt-value02').length > 0 && !$(el).closest('.ui-input').hasClass('noline')) {  //FETASK-1356 : 230905 : 오픈뱅킹 select-openbank 이고 두줄로 나와야 하는 경우
            if ($(el).find('option[selected]').index() != 0 && $(el).find('option[selected]').attr('data-all') == undefined) {
                $(el).closest('.ui-input').addClass('type3')
            }
        }
    }

    update(scrollMove = 'true') {
        // this.$el.find('option[data-value02="T"]').each((idx,el)=>{
        //     $(el).remove();
        // })
        const that = this;
        this.detachPopupEvents();
        initData(this);
        setSelectText(this);
        if (!this.$popup) {
            return;
        }
        let list, initialSlide, freeMode = false;
        let optionLength = 0;
        // 일반 계좌선택 타입 (오픈뱅킹 미사용자)
        if(this.defaults.type === 'select-double') {
            if (this.accountSelect === true && this.data.list[1].value02 !== undefined) {
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerBankList2Tmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.value01,
                        optionData.value02,
                        optionData.tag,
                        optionData.tagclass
                    )).join('');
            } else {
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerBankListTmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.value01,
                        optionData.value02,
                        optionData.tag,
                        optionData.tagclass
                    )).join('');
            }
        }

        // 오픈뱅킹 계좌선택 타입
        else if (this.defaults.type === 'select-openbank') {
            if (this.accountSelect === true && this.data.list[1].value02 !== undefined) {
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        if (obj.value !== '' && obj.is_opbk_acnt == 'true') {
                            optionLength++;
                        }
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerOpenBankList2Tmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.value01,
                        optionData.value02,
                        optionData.bank,
                        optionData.img,
                        optionData.tag,
                        optionData.tagclass,
                        optionData.is_opbk_acnt,
                    )).join('');
            } else {
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        if (obj.value !== '' && obj.is_opbk_acnt == 'true') {
                            optionLength++;
                        }
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerOpenBankListTmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.value01,
                        optionData.value02,
                        optionData.bank,
                        optionData.img,
                        optionData.tag,
                        optionData.tagclass,
                        optionData.is_opbk_acnt,
                    )).join('');
            }
            if (optionLength <= 2) {
                this.$popup.addClass('df');
            } else {
                this.$popup.removeClass('df');
            }
        }
        // 휴대폰번호 타입
        else if (this.defaults.type === 'select-phone') {
            list = this.data.list.filter((obj) => {
                if(this.defaults.optional){
                    return true;
                }else{
                    return obj.value !== '';
                }
            }).map((optionData) =>
                getBottomLayerSelectItemTmpl(
                    optionData.value,
                    optionData.selected,
                    optionData.disabled,
                    optionData.text
                )).join('');
        }

        // 은행/증권사 선택 타입
        else if (this.defaults.type === 'select-bank') {
            this.$popup.find('.select-list').addClass('bank')
            list = this.data.list.filter((obj) => {
                return obj.value !== '';
            });

            const bankList = list.filter(item => item.group === "bank");
            const stockList = list.filter(item => item.group === "stock");

            const bankfirmHTML = (obj, group) => {
                return obj.map((options) => {
                    const listHTML = getBottomLayerBankFirmItemTmpl(options.value, options.text, options.img, options.selected);

                    return getBottomLayerBankFirmListTmpl(listHTML, group);
                });
            }

            // const spacer = getBottomLayerBankFirmListTmpl('', '');
            list = bankfirmHTML(bankList, 'bank').concat(bankfirmHTML(stockList, 'stock'));
            //list = bankfirmHTML(bankList, 'bank').concat(spacer).concat(bankfirmHTML(stockList, 'stock'));
        }

        // 기본 타입
        else {
            if (this.defaults.item === 'account') { // 2023-06-13 |  FETASK-1066  | data-type="select-single" data-item="account" 일때 추가됨 ( select-single (계좌목록))
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerBankList2Tmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.value01,
                        optionData.value02,
                        optionData.tag,
                        optionData.tagclass
                    )).join('');
            } else {
                list = this.data.list.filter((obj) => {
                    if(this.defaults.optional){
                        return true;
                    }else{
                        return obj.value !== '';
                    }
                }).map((optionData) =>
                    getBottomLayerSelectItemTmpl(
                        optionData.value,
                        optionData.selected,
                        optionData.disabled,
                        optionData.text,
                        optionData.link,
                    )).join('');
            }

        }
        initialSlide = this.data.selectedIndex;
        if (this.$el.closest('.ui-input').attr('data-style') != undefined) {  // FETASK-1314 : 230811 : 셀렉트의 라인이 있는 경우 // 20231212 변경
            this.$popup.find('.select-list').addClass(this.$el.closest('.ui-input').attr('data-style'))
        }
        this.$popup.find('.select-list').html(list);
        if(!this.defaults.optional && this.data.selectedIndex > 0){
            initialSlide = this.data.selectedIndex-1;
        }else{
            initialSlide = this.data.selectedIndex;
        }

        this.$popup.find('.select-list').off('click.clickSelect').on('click.clickSelect', 'button', (e) => {
            if(isA11yCheckVersion()){
                Popup.a11yDetctClosePopup(); //팝업 닫힐시 다른 closeMotion영향안가게 분기 실행 메서드
            }

            if ($(e.currentTarget).attr('data-val') == 'self') { // 230717 |  셀렉트 직접입력 관련 추가, 230728 | 수정
                const $uiInput = that.$el.closest('[select-type="direct"]')
                $uiInput.addClass('active')
                $uiInput.find('[direct-input] input').val('')
                $uiInput.find('[direct-input] input').focus();
            } else {
                const $uiInput = that.$el.closest('[select-type="direct"]')
                if ($uiInput.length > 0) {
                    $uiInput.removeClass('active')
                }
            }

            // 콤보타입 (.ui-formBox) : 두번째 인풋으로 포커스 이동 됨
            if (!$(e.currentTarget).hasClass('ui-btn-animate')) {
                const $formBoxGroup = this.$el.closest('.form-box-group');
                if ($formBoxGroup.length > 0 && $formBoxGroup.find('input').length > 0) {
                    /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
                    if(isA11yCheckVersion()){
                        isA11ySelectInputCombo($formBoxGroup.find('input'), this.$el);

                        return;
                    }
                    /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */

                    setTimeout(() => {
                        $formBoxGroup.find('input').focus();
                    }, 0);
                }
            }
            // 셀렉트 delete 버튼 추가
            if (this.defaults.delbtn == 'show') {
                this.addDelBtn();
            }
            if (that.$el.attr('data-type') == 'select-double' && that.$el.attr('data-item') == 'account' && that.$el.closest('.ui-input').find('.txt-value02').length > 0 && !that.$el.closest('.ui-input').hasClass('noline')) {  //FETASK-1382 : 230828 : 오픈뱅킹 두줄 셀렉트 높이값 변경
                if ($(e.currentTarget).find('.area-option span.txt-option').length == 0 ||  $(e.currentTarget).find('.area-option span.txt-option').text() == '') {
                    that.$el.closest('.ui-input').removeClass('type3')
                } else {
                    that.$el.closest('.ui-input').addClass('type3')
                }
            }
            if (that.$el.attr('data-type') == 'select-openbank' && that.$el.attr('data-double') == 'true' && that.$el.closest('.ui-input').find('.txt-value02').length > 0 && !that.$el.closest('.ui-input').hasClass('noline')) {  //FETASK-1356 : 230905 : 오픈뱅킹 select-openbank 이고 두줄로 나와야 하는 경우
                // if ($(e.currentTarget).find('.area-option span.txt-option').length == 0 || $(e.currentTarget).find('.area-option span.txt-option').text() == '') {
                //     that.$el.closest('.ui-input').removeClass('type3')
                // } else {
                //     that.$el.closest('.ui-input').addClass('type3')
                // }
                if ($(e.currentTarget).closest('.select-item').find('.one-val').length > 0) {
                    that.$el.closest('.ui-input').removeClass('type3')
                } else {
                    that.$el.closest('.ui-input').addClass('type3')
                }
            }
        })

        this.nowSelected = initialSlide;
        if (scrollMove === 'true') {
            this.scrollToSelected();
        }

        if (this.accountSelect === true) {
            this.$popup.addClass('ui-bottom-account');
        } else {
            this.$popup.removeClass('ui-bottom-account');
        }

        this.attachPopupEvents();
    }

    defaultSelected(){
        if (this.$el.val() !== '') {
            this.addDelBtn();
        }
    }
    /**
    * 인풋 모양의 셀렉트 박스에서  delete 버튼 추가시 사용
    * @example 
    * $('.custom-ui').data('ui').addDelBtn();
    */
    addDelBtn() {
        const $selectboxGroup = this.$el.parents('.selectbox-group');
        if (!$selectboxGroup.find('.custom-ui').hasClass('active')) {
            $selectboxGroup.find('.ui-select-btn').after(getSelectButtonClose());
            $selectboxGroup.find('.bl-selectbox').stop().animate({
                'opacity' : 0
            }, 200, function(){
                $selectboxGroup.find('.bl-selectbox').css('display','none');
            });
            $selectboxGroup.find('.custom-ui').addClass('active');

            // btn-delete-select 버튼 클릭시
            $(document).off('click.btnDeleteSel').on('click.btnDeleteSel', '.btn-delete-select', (e) => {
                e.preventDefault();
                const $selectboxGroup = this.$el.parents('.selectbox-group');
                $selectboxGroup.find('.bl-selectbox').css('display','block');
                $selectboxGroup.find('.bl-selectbox').stop().animate({
                    'opacity' : 1
                });
                this.reset(); // 셀렉트 초기화 함수 실행
            })
        }
    }

    scrollToSelected(){
        const selectedItem = this.data.selectedIndex === 0 ? this.$popup.find('.select-item').eq(0) : this.$popup.find('.select-item .selected').closest('.select-item');
        const _this = this;
        // console.log('popupSelect.js :: scrollToSelected()')
        // 확인 필요 241213   셀렉트 반팝업 작업중 선택된 값 스크롤 이동을 막음  여기 사용하는곳 확인 필요 
        // setTimeout(function(){
        //     if(selectedItem[0]){
        //         const nowScrollT = _this.$popup.find('.popup-content').scrollTop();
        //         const parentOffset = _this.$popup.find('.popup-content')[0].getBoundingClientRect().top;
        //         const parentHeight = _this.$popup.find('.popup-content')[0].getBoundingClientRect().height;
        //         const targetOffset = selectedItem[0].getBoundingClientRect().top;
        //         const targetHeight = selectedItem[0].getBoundingClientRect().height;
        //         if (parentOffset + parentHeight - targetHeight < targetOffset || parentOffset > targetOffset) {
        //             _this.$popup.find('.popup-content').scrollTop(targetOffset - parentOffset + nowScrollT - 5);
        //             // frontUI.scrollTo(selectedItem);
        //         }
        //     }
        // },600)


        
        // A11YTASK-190 : 접근성대응(2025-03-04)
        this.$popup.find('.select-item').each(function(idx,el){
            if ($(el).find('button').hasClass('selected')) {
                if ($(el).closest('[data-type]')?.length > 0) {
                    if(isA11yCheckVersion() && $(el).closest('[data-type]').attr('data-type') !== 'select-bank') { //A11YTASK-192 : 접근성대응 (2025.05.30)
                        $(this).find('button').attr('title', '선택됨'); 
                    }
                } 
            } else {
                $(this).find('button').attr('title', null); 
            }
        })
    }

    render() {
        if (this.$popup) { // FETASK-1182 : 230816 :  셀렉트 직접입력관련 | 직접입력으로 숫자 입력시 숫자가 셀렉트 option 태그에 값과 일치하면 3,000,000원이 아닌 300만원 출력하는데 그때  셀렉트팝업 리스트에도  셀렉트가 되게끔 추가 ...
            if (this.$popup.find('[data-val="self"]')) {
                let selectIndex = 0;
                for (var i = 0; i < this.data.list.length; i++) {
                    if (this.data.list[i].el.attributes.selected != undefined) {
                        selectIndex = i
                    }
                }
                this.$popup.find('.select-item').each(function(idx,el){
                    $(el).find('button').removeClass('selected');
                    $(el).find('button').attr('title', null); // A11YTASK-190 : 접근성대응(2025-03-04)
                })
                this.$popup.find('.select-item').each(function(idx,el){
                    if (idx+1 == selectIndex) {
                        $(el).find('button').addClass('selected');
                        if ($(el).closest('[data-type]')?.length > 0) {
                            if(isA11yCheckVersion() && $(el).closest('[data-type]').attr('data-type') !== 'select-bank') { //A11YTASK-192 : 접근성대응 (2025.05.30)
                                $(el).find('button').attr('title', '선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
                            }
                        } 
                    } else {
                        $(el).find('button').attr('title', null); // A11YTASK-190 : 접근성대응(2025-03-04)
                    }
                    //$(el)[i-1].find('.button').addClass('selected')
                })
            } 
        }
        if (!this.$popup) {
            const selectTitle = this.$el.next('button').attr('title');
            const selectSubTitle = this.$el.next('button').attr('data-sub-title');
            this.$popup = $(getBottomLayerTmpl(this.defaults.type, selectTitle, selectSubTitle, this.defaults.addButton, this.$el.attr('add-button-text'), this.defaults.plusboxButton, this.$el.attr('plusbox-button-text'))); // FETASK-1382 : 셀렉트 팝업 하단 버튼 필요할때 .custom-ui 클래스태그에  data-add-button="" 값 // CHPFMTASK-2128 플러스박스 만들기 2025-04-07
            this.$popupContainer.append(this.$popup);
            this.$popup.attr('data-id', this.uiId);

            const titleStr =  selectTitle.replace(/\s/g, '');

            if (this.defaults.item === 'account') {
                this.accountSelect = true;
            }
            // if (titleStr.indexOf('통장을선택해주세요') > -1 ) {
            //     this.accountSelect = true;
            // }
            this.update();
            
        }

        if(this.datas.list.length <= 1 && this.datas.list[0].value === ''){
            return;
        }

        // this.openMotion();
        this.openCallbackAction();
    }

    openMotion() {
        this.openCommonMotion({
            cancelMotion: false,
            callback: () => {
            }
        });
        this.scrollToSelected();

        /*! s: FETASK-a11y page 팝업 접근성 속성 및 focus로직 v.1.0.0 */
        this.a11yPopupAccess();
        /*! e: FETASK-a11y page 팝업 접근성 속성 및 focus로직 v.1.0.0 */
    }

    closeMotion() {
        this.closeCommonMotion({
                cancelMotion: false,
                callback: () => {
                }
            }
        );
        
        /*! s: FETASK-a11y page 팝업 접근성 속성 및 focus로직 v.1.0.0 */
        this.a11yPopupInit();
        /*! e: FETASK-a11y page 팝업 접근성 속성 및 focus로직 v.1.0.0 */
    }

    accessOpen() {
        this.$popupContainer.siblings().attr('aria-hidden', 'true');
    }

    accessClose() {
        super.accessClose();
    }

    open(fn = () => {
    }) {
        fn();

        setTimeout(() => {
            this.render();
        }, 0);
    }

    close(fn = () => {
    }) {
        fn();

        this.closeMotion();
    }

    /**
     * 셀렉트 열기 이전 시점 콜백 
     * @param {function} callback 
     * @example 
     * $('.custom-ui').data('ui').beforeOpenCallback(function(){
     *      $('.custom-ui').data('ui').open()
     * });
     */
     beforeOpenCallback(callback) {
        this.openCallback = callback;
    }

    openCallbackAction() {
        if (this.openCallback && $.isFunction(this.openCallback)) this.openCallback(this.data.list[this.selectedIndex].el.dataset, this.selectedIndex, this.data.list);
        this.openMotion();
    }

    /**
     * 셀렉트 닫기 이전 시점 콜백 
     * @param {function} callback 
     * @example 
     * $('.custom-ui').data('ui').beforeCloseCallback(function(){
     *      $('.custom-ui').data('ui').close()
     * });
     */
    beforeCloseCallback(callback) {
        this.closeCallback = callback;
    }

    closeCallbackAction() {
        if (this.closeCallback && $.isFunction(this.closeCallback)) {
            this.closeCallback(this.data.list[this.selectedIndex].el.dataset, this.selectedIndex, this.data.list);
        } else {
            this.closeMotion();
        }
    }

    /**
     * 셀렉트 delete 버튼 클릭 시점 콜백 
     * @param {function} callback 
     * @example 
     * $('.custom-ui').data('ui').beforeResetCallback(function(){
     *      $('.custom-ui').data('ui').close()
     * });
     */
    beforeResetCallback(callback) {
        this.resetCallback = callback;
    }

    resetCallbackAction() {
        if (this.resetCallback && $.isFunction(this.resetCallback)) {
            this.resetCallback(this.data.list[this.selectedIndex].el.dataset, this.selectedIndex, this.data.list);
        }
    }

    attachEvents() {
        this.$el.closest('.form-row').find('[data-role="tag-btn-wrap"] .tag').off(`click${this.eventId}`).on(`click${this.eventId}`, (e) => {
            e.preventDefault();
            const target = $(e.currentTarget);
            const bankText = target.text();
            const bankOpt = this.$el.find('option');
            bankOpt.each((idx, el) => {
                if ($(el).text() === bankText) {
                    this.$el.val($(el).attr('value'));
                    setTimeout(() => {
                        if (this.defaults.delbtn == 'show') {
                            this.defaultSelected();
                        }
                    }, 200)
                }
            })
        })
        this.$el.next('button').on(`click${this.eventId}`, (e) => {
            e.preventDefault();

            if(isA11yCheckVersion()){
                //mobile select 기능 옵션 disabled있을시 동작 안되게 처리
                const isCheckDisabled = $(e.currentTarget).attr('disabled');

                if(isCheckDisabled) return;
            }

            this.render();
        });
    }

    detachEvents() {
        this.$el.off(this.eventId);
        this.$el.next('button').off(this.eventId);
        this.$el.closest('.form-row').find('[data-role="tag-btn-wrap"] .tag').off(this.eventId)
    }

    attachPopupEvents() {
        this.$popup.on(`click${this.eventId}`, (e) => {
            e.preventDefault();

            if (e.target === e.currentTarget) {
                this.closeCallbackAction();
            }
        });

        this.$popup.on(`click${this.eventId}`, '.select-item button', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            
            const linkedPopup = $this[0].dataset.link;
            // console.log('$this', $this)
            if (linkedPopup !== undefined) {
                this.closeCallbackAction();
               $(`.${linkedPopup}`).data('ui').open();

                return false;
            }

            let index;
            const row = $this.closest('li').index();
            // 선택적,필수적 조건은 사용 안할 수도 있음
            if(this.defaults.optional){
                index = row
            }else{
                index = row + 1
            }
            if ($this.hasClass('ui-btn-animate')) {
                $this.addClass('animate-btn');
                $this.on('animationend', () => {
                    $this.removeClass('animate-btn');
                    $this.off('animationend');
                });
                if (this.dataReloadFn && $.isFunction(this.dataReloadFn)) {
                    this.dataReloadFn(this.datas.list[index]);
                }
                return false;
            }

            // stock일경우 spacer가 존재하므로 -1해준다.
            // if($this.closest('li').hasClass('stock')){
            //     index -= 1;
            // }

            this.$popup.find('.btn-option').removeClass('selected');
            $this.addClass('selected');
            
            /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
            // if(isA11yCheck){ // CHPFMTASK-1714 삭제
            //     this.$popup.find('.btn-option').attr('aria-checked','false');
            //     $this.attr('aria-checked', 'true');
            // }
            /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */

            // A11YTASK-134
            // console.log('$this', $this)

            this.$popup.find('.btn-option').attr('title', null); // A11YTASK-190 : 접근성대응(2025-03-04)
            if(isA11yCheckVersion() && this.defaults.type !== 'select-bank'){ //A11YTASK-192 : 접근성대응 (2025.05.30)
                $this.attr('title', '선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
            }
            

            if(this.data.selectedIndex !== index){
                this.data.selectedIndex = index;
                this.$el[0].selectedIndex = index;
                this.$el.trigger('change');

                // select > option 의 selected attr update
                if ( this.$el[0].selectedIndex !== this.$el.find('option[selected]').index() ) {
                    this.$el.find('option[selected]').attr('selected', false);
                    this.$el.find('option').eq(index).attr('selected', true);


                    
                }
            }
            setSelectText(this);

            if (this.callbackFn && $.isFunction(this.callbackFn)) {
                setTimeout(() => this.callbackFn(this.datas.list[index]));
            }

            this.closeCallbackAction();
            //this.$el.next('button').focus();

            /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
            if(isA11yCheck && this.defaults.type !== 'select-bank'){
                //TODO - select닫힐때 버그 수정 필요
                Popup.a11yDetctClosePopup();
                
                const isCheckLength = this.$el.closest('.ui-formBox').find('.form-box-item').length;
                const selectNextEle = this.$el.closest('.ui-formBox').find('.form-box-item').eq(isCheckLength - 1 );

                if(isCheckLength >= 2) {
                    setTimeout(() =>{
                        //선택한 셀렉트박스로 포커스 닫히고 이동
                        selectNextEle?.find('button')?.focus();
                        console.log(23213123)
                    },500);
                }else{
                    setTimeout(() =>{
                        //선택한 셀렉트박스로 포커스 닫히고 이동
                        isA11yForceTargetFocus(this.$el, 10);
                    },500);
                }
                
            }
            /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
        });

        this.$popup.on(`click${this.eventId}`, '.btn-close-popup', (e) => {
            e.preventDefault();

            this.closeCallbackAction();
            this.$el.next('button').focus();
        });

        this.$dimm.on(`click${this.eventId}`, (e) => {
            e.preventDefault();

            this.closeCallbackAction();

        });

        if (this.defaults.type === 'select-openbank') {
            if (typeof this.scrollCallbackFn !== 'undefined') {
                const that = this;
                this.$popup.find('.popup-content').off('scroll.loadedItem').on('scroll.loadedItem', function(){
                    if (!that.$popup.find('.popup-content').hasClass('loaded-item')) {
                        that.$popup.find('.popup-content').addClass('loaded-item');
                        that.scrollCallbackFn();
                        that.scrollCallbackFn = null;
                        that.$popup.find('.popup-content').off('scroll.loadedItem')
                    }
                })
            }
        }

        /*! s: FETASK-a11y page Popup 수정 v.1.0.0 */
        if(isA11yCheckVersion()){
            this.$popup.on(`click${this.eventId}`, '.close-btn', (e) => {
                e.preventDefault();

                Popup.a11yDetctClosePopup();
            });
        }
        /*! e: FETASK-a11y page Popup 수정 v.1.0.0 */
    }

    detachPopupEvents() {
        this.$popup && this.$popup.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
        this.detachPopupEvents();
    }

    /**
     * 선택된 값 reset
     * @example 
     * $('.custom-ui').data('ui').reset();
     */
    reset() {
        const $selectboxGroup = this.$el.parents('.selectbox-group');
        $selectboxGroup.find('.btn-delete-select').remove();
        $selectboxGroup.removeClass('done');
        $selectboxGroup.find('.custom-ui').removeClass('active');
        $selectboxGroup.find('.bl-selectbox').css('display','block');
        $selectboxGroup.find('.bl-selectbox').stop().animate({
            'opacity' : 1
        }, 200);

        if(this.$el.val !== ''){
            this.$el.find('option[selected]').prop('selected', false).attr('selected', false);
            this.$el.find('option').eq(0).prop('selected', true).attr('selected', true);
            this.data.selectedIndex = 0;
            this.nowSelected = this.data.selectedIndex;
            this.$el.trigger('change');
            if (typeof this.$popup !== 'undefined') {
                this.$popup.find('.btn-option').removeClass('selected');
            }
        }

        if (this.defaults.type === 'select-bank') {
            setSelectText(this)
        };

        setTimeout(() => {
            this.resetCallbackAction();
        }, 250); //  reset() 안 animate delay 값 보다 더
    }

    /**
     * 일반적인 콜백 함수
     * @param {Function} fn 콜백 함수
     * @example
     *  var select = $('select').data('ui');
     *  select.callback(function(index){
     *      console.log('index', index);
     *  });
     */
    callback(fn) {
        this.callbackFn = fn;
    }

    /**
     * 오픈뱅킹 계좌조회 새로고침
     * @param {Function} fn 오픈뱅킹 계좌조회 새로고침 함수, update 함수 추가 호출 필요
     * @example
     *  var select = $('select').data('ui');
     *  select.dataReload(function(index){
     *      console.log('index', index);
     *  });
     */
    dataReload(fn) {
        this.dataReloadFn = fn;
    }
    
    /**
     * 오픈뱅킹 계좌목록 팝업 스크롤 이벤트 추가
     * @param {Function} fn 오픈뱅킹 계좌조회 스크롤 이벤트 함수, update 함수 추가 호출 필요
     * @example
     *  $('select').data('ui').scrollCallback(function(){});
     */
    scrollCallback(callback){
        this.scrollCallbackFn = callback;
        const that = this;
        if (this.$popup) {
            this.$popup.find('.popup-content').off('scroll.loadedItem').on('scroll.loadedItem', function(){
                if (!that.$popup.find('.popup-content').hasClass('loaded-item')) {
                    that.$popup.find('.popup-content').addClass('loaded-item');
                    that.scrollCallbackFn();
                    that.scrollCallbackFn = null;
                    that.$popup.find('.popup-content').off('scroll.loadedItem');
                }
            })
        }
    }

    get selectedIndex() {
        return this.data.selectedIndex;
    }

    get datas() {
        return this.data;
    }

    /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
    a11yPopupAccess(){
        //셀렉트 팝업 열림
        const _this = this;
        requestAnimationFrame(() => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
            if(isA11yCheck){
                const popupWrap = document.querySelector('.popup-wrap');
                const popupEles = document.querySelectorAll('.ui-popup'); //모든팝업 선택

                popupWrap.removeAttribute('tabindex');
                
                isA11yRemoveClass(popupEles, 'activePoup');
                _this.$popup[0].classList.add('activePopup'); //현재 활성화된 팝업만 active 클래스 추가

                isA11ySetAttr(popupEles,'aria-hidden', 'true');
                _this.$popup[0].parentElement.removeAttribute('aria-hidden');
                
                if(Popup.arrPrePopup?.length > 1){
                    const popupWrapEles = document.querySelectorAll('.popup-wrap');
                    isA11ySetAttr(popupWrapEles,'aria-hidden', 'true');
                    _this.$popup[0].parentElement.removeAttribute('aria-hidden');
                }
                
                const selectBtnEle = document.querySelector('.activeSlide select[data-type="select-bank"]')?.nextElementSibling 
                                    || 
                                    document.querySelector('.activeSlide select[data-type="select-double"]')?.nextElementSibling
                                    ||
                                    document.querySelector('.activeSlide select[data-type="select-single"]')?.nextElementSibling;
                selectBtnEle && selectBtnEle.blur(); //팝업 오픈시 해당영역에 focus가 계속 되있어서 dimm닫고 다시 클릭시 #파라미터 붙으면서 상위로 이동되는 현상 방지
                

                _this.$popup[0].setAttribute('aria-hidden', 'false');
                _this.$popup[0].setAttribute('tabindex', '0');

                

                setTimeout(() => {
                    _this.$popup?.find('.close-btn')
                        ?.attr('style', `
                            position:fixed;
                            top:0;
                            left:0;
                            z-index:-9999;
                            width:100%;
                            height:calc(100% - ${this.$popup.find('.popup-group').outerHeight()}px);
                        `);
                },700);

                //select열림시 focus
                //isA11ySelectPopupOpenFocus(_this.$popup[0]); 공통팝업 open로직 처리 추후 삭제

                //팝업 닫기버튼 추가
                //isPopupMakeCloseButtonOne(_this.$popup);

                //console.log('this popup', _this.$popup)

                //selectbox popup 적용
                isA11yRadioGroup(_this.$popup); //radiogroup적용

                const btnSelectedEles = _this.$popup[0].querySelectorAll('.btn-option.selected , .btn-trn-option.selected');
                btnSelectedEles && isA11ySetAttr(Array.from(btnSelectedEles), 'aria-checked', 'true');
                btnSelectedEles && isA11ySetAttr(Array.from(btnSelectedEles), 'role', 'radio');
                
                
                /**스크롤 여부 적용 */
                setTimeout(() => {
                    const popWrapEle = this.$popup[0].querySelector('.popup-content');

                    if(popWrapEle){
                        popWrapEle.classList.add('on');
                        popWrapEle.removeAttribute('tabindex');
                    }
                });
            }
        });
    }

    a11yPopupInit(){
        //팝업 닫기
        requestAnimationFrame(async() => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행

            if(isA11yCheck && this.defaults.type !== 'select-bank'){
                if(Popup.arrPopup?.length){
                    Popup.arrPopup[0].attr('aria-hidden','false');
                }
                /**스크롤 여부 적용제거 */
                const popWrapEle = this.$popup[0].querySelector('.popup-content');

                if(popWrapEle){
                    popWrapEle.classList.remove('on');
                    popWrapEle.removeAttribute('tabindex');
                }

                Popup.a11yDetctClosePopup();// 팝업 셀렉트 닫힐때 해당 로직 안타게 수정

                const isCheckLength = this.$el.closest('.ui-formBox').find('.form-box-item').length;
                
                if(isCheckLength >= 2) {
                    setTimeout(() =>{
                        //선택한 셀렉트박스로 포커스 닫히고 이동isA11yCheckVoiceOverFocusPrevent();
                        this.$el?.next()?.focus();
                    },500);
                }else{
                    setTimeout(() =>{
                        //선택한 셀렉트박스로 포커스 닫히고 이동
                        isA11yForceTargetFocus(this.$el, 10);
                    },500);
                }
            }else{
                //은행 증권사 선택 select-box type
                this.$el.next('.no-label')?.focus();
            }
        });
    }
    /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
}

export default PopupSelect;
